import { useState, useEffect } from "react";
import { login, checkMicrosoftEnabled } from "../api";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [msftEnabled, setMsftEnabled] = useState(false);

  useEffect(() => {
    checkMicrosoftEnabled()
      .then((data) => setMsftEnabled(data.enabled))
      .catch(() => {});

    // Show auth errors passed via query string from OAuth callback
    const params = new URLSearchParams(window.location.search);
    const authError = params.get("auth_error");
    if (authError) {
      setError(decodeURIComponent(authError));
      window.history.replaceState({}, "", "/");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(username, password);
      onLogin(data.user);
    } catch (err) {
      setError(err.message || "Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  const handleMicrosoftLogin = () => {
    const base = process.env.REACT_APP_API_URL || "";
    window.location.href = `${base}/api/auth/microsoft`;
  };

  return (
    <div className="login-page">
      <div className="search-bg-overlay" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/tharros-t.png)` }} />
      <form className="login-card" onSubmit={handleSubmit}>
        <h2 className="login-title">VINCE-NT VulScope</h2>
        {error && <div className="login-error">{error}</div>}
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="login-input"
          autoFocus
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
        />
        <button type="submit" className="login-btn" disabled={loading}>
          {loading ? "Signing in..." : "Sign in"}
        </button>

        {msftEnabled && (
          <>
            <div className="login-divider"><span>or</span></div>
            <button
              type="button"
              className="login-btn login-btn-microsoft"
              onClick={handleMicrosoftLogin}
            >
              Sign in with Microsoft
            </button>
          </>
        )}
      </form>
    </div>
  );
}
